// extracted by mini-css-extract-plugin
export var button = "GooglePayButton-module__button___cG6VN";
export var container = "GooglePayButton-module__container___wXVzi";